import React, { useState, useEffect } from 'react';
import { detailsStrategy } from '../statusStrategy';
import { ResultDetailsWrap } from './ResultDetailsWrap';
import { ResultDetails } from './ResultDetails';
import styled from 'styled-components';
import Form from './Form';
import { BtnGray } from '../../StyledComponents';
import Grid from '@material-ui/core/Grid'

// functions and properties
const SuccessMessage = styled.a`
  display: block;
  cursor: pointer;
  margin: 20px 5px 5px;
  padding: 12px;
  font-size: 14px;
  color: white;
  border-radius: 10px;
  background-color: ${({theme}) => theme.SECONDARY_COLOR};
  text-align: center;

  a {
    color: white !important;
    text-decoration: underline;
  }
`;

const GrayBtn = styled(BtnGray)`
  width: 100%;
  height: 100%;
`;

export default function QualificationDetails({
  qualifiedStatus,
  address,
  isQualified,
  sendEmail,
  jobs
}) {
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    setShowSuccess(false);
  }, [address])

  function openLink(url) {
    window.open(url);
  }

  return (
    <ResultDetailsWrap>
      <ResultDetails style={{margin: 5}} dangerouslySetInnerHTML={
        {__html: detailsStrategy[qualifiedStatus](Math.ceil(jobs))}
      } />
      {
        isQualified && !showSuccess &&
        <Form 
          onSubmit={
            (form, reset, cb) => sendEmail(form, reset, () => {
              setShowSuccess(true); 
              cb()
            })
          }
        />
      }
      {
        showSuccess &&
        <SuccessMessage>
          Check for an email from Jeremy Shackle, EB5AN Senior Associate. <br/> To discuss your EB-5 project with 
          him, <a href="https://go.oncehub.com/JeremyShackle3" target="_blank">click here to schedule a call.</a>
        </SuccessMessage>
      }
      {/* four gray buttons */}
      {
        isQualified &&
        <Grid container wrap="wrap">
          <Grid item xs={6} style={{padding: 5}}>
            <GrayBtn style={{fontSize: 13}} onClick={() => openLink('https://go.oncehub.com/JeremyShackle3')}>
              Get Fast EB-5 Job Help
            </GrayBtn>
          </Grid>
          <Grid item xs={6} style={{padding: 5}}>
            <GrayBtn style={{fontSize: 13}} onClick={() => openLink('https://eb5visainvestments.com/')}>
              View High-Quality <span style={{whiteSpace: 'pre'}}>EB-5 Projects</span>
            </GrayBtn>
          </Grid>
          <Grid item xs={6} style={{padding: 5}}>
            <GrayBtn style={{fontSize: 13}} onClick={() => openLink('https://eb5affiliatenetwork.com/eb-5-tea-map/')}>
              Determine TEA Status
            </GrayBtn>
          </Grid>
          <Grid item xs={6} style={{padding: 5}}>
            <GrayBtn style={{fontSize: 13}} onClick={() => openLink('https://eb5affiliatenetwork.com/resources/ ')}>
              Learn More About EB-5
            </GrayBtn>
          </Grid>
        </Grid>
      }
    </ResultDetailsWrap>
  );
};
